import { isLocal } from '@/utils/baseUrl';
import { doGet, doPost } from '@/utils/request';

// client请求接口
let domain = 'lcscActivityUrl';
if (isLocal) {
  domain = 'https://devactivity.szlcsc.com';
}

// 是否可用海外代购优惠券
export function isCounponUnavailableForOversea() {
  return doGet(domain, '/v2/is/coupon/unavailable/for/oversea');
}

// 获取海外代购优惠券
export function activityOverseaCouponTips(body) {
  return doPost(domain, '/activity/oversea/coupon/tips', body);
}

// 抢优惠券
export function getCoupon(query) {
  const uuid = isLocal ? 'DCEE83225264E314D3BCCCC922B28413' : query.uuid;
  return doGet(domain, `/getCoupon/${uuid}`);
}

// 获取优惠券
export function activityCoupon(query) {
  return doGet(domain, '/v2/activity/coupon', query);
}

// 获取优惠套装
export function selectPackagePromotion(query) {
  return doGet(domain, '/select/package/promotion/v2', query);
}

// 获取运营标签
export function selectProductLabel(body) {
  return doPost(domain, '/select/sku/tag', body);
}

// 派发优惠券接口
export function sendCouponPopup(query) {
  return doGet(domain, '/new/send/coupon/popup', query);
}

export function diversionSendCoupon(query) {
  return doGet(domain, '/diversion/send/coupon/v2', query);
}

// 获取弹窗类型
export function getMarketAlertSearch() {
  return doGet(domain, '/market/alert/search', {}, { noErrorModal: true });
}

// 获取优惠券
export function getMarketCouponLabelShow(body) {
  return doPost(domain, '/coupon/label/show', body);
}
